"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.booleanAnswerToNumber = booleanAnswerToNumber;
function booleanAnswerToNumber(answer) {
    switch (answer) {
        case true:
            return 1;
        case false:
            return -1;
        case null:
            return 0;
        case undefined:
            return undefined;
    }
}
